var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shadow-sm d-flex flex-column full-height-modal bg-light"},[_c('conversation-initialize'),_c('conversation-messages'),_c('conversation-actions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }